import React from 'react';
import './chatComponent.css';
import MessengerInput from './messengerInput';
import MessageList from './MessageList';

const ChatComponent = () => {
    const id = window.location.pathname.split('/').pop();

    return (
        <div className='chatSide'>
            <div className='chatContent'>
                <div className='dialogContent'>
                    <MessageList id={id} />
                    <MessengerInput id={id}/>
                </div>
            </div>
        </div>
    );
};

export default ChatComponent;
